import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { BoosterWagerBonus, UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import styled from 'styled-components'
import BonusInvalid from '../../../BonusInvalid'
import BonusContentBoostedAmount from '../Common/BonusContentBoostedAmount'
import BonusContentExpiryDate from '../Common/BonusContentExpiryDate'
import BonusItemName from '../Common/BonusItemName'

interface BonusItemProps {
  bonus: UserBonus
}

const SimpleActiveBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  return (
    <Flex flexDirection="column" justifyContent="space-between" height="100%">
      <BonusItemName bonus={bonus} mb="8px" />

      {bonus instanceof BoosterWagerBonus && <BonusContentBoostedAmount bonus={bonus} />}
      {!(bonus instanceof BoosterWagerBonus) && (
        <Box mt="8px">
          <BonusContentExpiryDate bonus={bonus} />
        </Box>
      )}
      <Flex width="100%" mt="8px">
        {bonus.condition.isExpired && <StyledBonusInvalid bonus={bonus} />}
      </Flex>
    </Flex>
  )
}

const StyledBonusInvalid = styled(BonusInvalid)`
  height: 40px;
  border-radius: 8px;
  white-space: nowrap;
  box-sizing: border-box;
  padding: 0px !important;
  flex: 1 1;
  font-size: 14px;
  font-weight: bold;
`

export default SimpleActiveBonusContent
